import Autocomplete from "react-google-autocomplete";
import React from "react";
import { googleApiKey } from "../../services/CommonUrl";
import TimePicker from "react-bootstrap-time-picker";
import { timeFromInt } from "time-number";
import DatePicker from "react-datepicker";
import TextareaAutosize from "react-textarea-autosize";
import moment from "moment";

export const currencyList = [
  { code: "USD", name: "United States Dollar" },
  { code: "EUR", name: "Euro" },
  { code: "JPY", name: "Japanese Yen" },
  { code: "GBP", name: "British Pound Sterling" },
  { code: "AUD", name: "Australian Dollar" },
  { code: "CAD", name: "Canadian Dollar" },
  { code: "CHF", name: "Swiss Franc" },
  { code: "CNY", name: "Chinese Yuan" },
  { code: "SEK", name: "Swedish Krona" },
  { code: "NZD", name: "New Zealand Dollar" },
  { code: "MXN", name: "Mexican Peso" },
  { code: "SGD", name: "Singapore Dollar" },
  { code: "HKD", name: "Hong Kong Dollar" },
  { code: "NOK", name: "Norwegian Krone" },
  { code: "KRW", name: "South Korean Won" },
  { code: "TRY", name: "Turkish Lira" },
  { code: "INR", name: "Indian Rupee" },
  { code: "RUB", name: "Russian Ruble" },
  { code: "BRL", name: "Brazilian Real" },
  { code: "ZAR", name: "South African Rand" },
  { code: "DKK", name: "Danish Krone" },
  { code: "PLN", name: "Polish Zloty" },
  { code: "THB", name: "Thai Baht" },
  { code: "IDR", name: "Indonesian Rupiah" },
  { code: "HUF", name: "Hungarian Forint" },
  { code: "CZK", name: "Czech Koruna" },
  { code: "ILS", name: "Israeli New Shekel" },
  { code: "CLP", name: "Chilean Peso" },
  { code: "PHP", name: "Philippine Peso" },
  { code: "AED", name: "United Arab Emirates Dirham" },
  { code: "COP", name: "Colombian Peso" },
  { code: "SAR", name: "Saudi Riyal" },
  { code: "MYR", name: "Malaysian Ringgit" },
  { code: "RON", name: "Romanian Leu" },
];

const DateField = ({ formik, fieldName, labelName }) => {
  return (
    <div className="d-col-input-field">
      <label className="form-label">{labelName}</label>
      <DatePicker
        selected={formik.values[fieldName]}
        // value={value}
        onChange={(value) => formik.setFieldValue(fieldName, value)}
        onBlur={formik.handleBlur(fieldName)}
        name={fieldName}
        dateFormat="dd-MM-yyyy"
        customInput={
          <input
            className="form-control d-dateIcon"
            type="text"
            autoComplete="off"
          />
        }
        placeholderText="Select Date"
        minDate={new Date()}
      />
      {formik.touched[fieldName] && formik.errors[fieldName] ? (
        <p className="errors-msg">{formik.errors[fieldName]}</p>
      ) : null}
    </div>
  );
};

const DateTimeField = ({
  formik,
  fieldName,
  labelName,
  minDate,
  maxDate,
  type,
  disabled,
}) => {
  return (
    <div className="d-col-input-field">
      <label className="form-label">{labelName}</label>
      <DatePicker
        selected={formik.values[fieldName]}
        value={formik.values[fieldName]}
        onChange={(value) => formik.setFieldValue(fieldName, value)}
        onBlur={formik.handleBlur(fieldName)}
        name={fieldName}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        dateFormat="dd-MM-yyyy HH:mm"
        autoComplete="off"
        customInput={
          <input
            className="form-control d-dateIcon"
            type="text"
            autoComplete="off"
          />
        }
        placeholderText="Select Date & Time"
        minDate={new Date(minDate)}
        maxDate={new Date(maxDate)}
        filterDate={() => (type ? false : true)}
        // disabled={disabled}
      />
      {formik.touched[fieldName] && formik.errors[fieldName] ? (
        <p className="errors-msg">{formik.errors[fieldName]}</p>
      ) : null}
    </div>
  );
};

const TextInputField = ({ formik, fieldName, labelName, placeHolder }) => {
  return (
    <div className="d-col-input-field">
      <label className="form-label">{labelName}</label>
      <input
        className="form-control"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        name={fieldName}
        type="text"
        value={formik.values[fieldName]}
        placeholder={placeHolder}
      />
      {formik.touched[fieldName] && formik.errors[fieldName] ? (
        <p className="errors-msg">{formik.errors[fieldName]}</p>
      ) : null}
    </div>
  );
};

const SelectDropDownField = ({ formik, fieldName, labelName, options }) => {
  return (
    <div className="d-col-input-field">
      <label className="form-label">{labelName}</label>

      <select
        className="form-select"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        name={fieldName}
        value={formik.values[fieldName]}
      >
        <option value="">Select</option>
        {options.map((item, index) => {
          return (
            <option key={index} value={item}>
              {item}
            </option>
          );
        })}
      </select>
      {formik.touched[fieldName] && formik.errors[fieldName] ? (
        <p className="errors-msg">{formik.errors[fieldName]}</p>
      ) : null}
    </div>
  );
};

const TextAreaInputField = ({ formik, fieldName, labelName, placeHolder }) => {
  return (
    <div className="d-col-input-field">
      <label className="form-label">{labelName}</label>
      <TextareaAutosize
        className="form-control"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        name={fieldName}
        value={formik.values[fieldName]}
        placeholder={placeHolder}
        minRows={2}
      />
      {formik.touched[fieldName] && formik.errors[fieldName] ? (
        <p className="errors-msg">{formik.errors[fieldName]}</p>
      ) : null}
    </div>
  );
};

const AddressInputField = ({
  formik,
  fieldName,
  labelName,
  placeHolder,
  setLatLng,
}) => {
  return (
    <div className="d-col-input-field">
      <label className="form-label">{labelName}</label>
      <Autocomplete
        apiKey={`${googleApiKey}`}
        options={{ types: ["geocode", "establishment"] }}
        onPlaceSelected={(place) => {
          formik.setFieldValue(fieldName, place.formatted_address);
          setLatLng({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          });
        }}
        value={formik.values[fieldName]}
        name={fieldName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        placeholder={placeHolder}
        className="form-control"
      />
      {formik.touched[fieldName] && formik.errors[fieldName] ? (
        <p className="errors-msg">{formik.errors[fieldName]}</p>
      ) : null}
    </div>
  );
};

const CostInputField = ({ formik, fieldName, labelName, placeHolder }) => {
  return (
    <>
      <div className="d-col-input-field">
        <label className="form-label">{labelName}</label>
        <div className="input-group">
          <select
            className="form-select mw-100px"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            name={"currency"}
            value={formik.values.currency}
          >
            {currencyList.map((item, index) => {
              return (
                <option key={index} value={item.code}>
                  {item.code}
                </option>
              );
            })}
          </select>
          <input
            className="form-control"
            type="number"
            min="1"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            name={fieldName}
            value={formik.values[fieldName]}
            placeholder={placeHolder}
          />
        </div>
      </div>
      {formik.touched[fieldName] && formik.errors[fieldName] ? (
        <p className="errors-msg">{formik.errors[fieldName]}</p>
      ) : null}
    </>
  );
};

const TimeInputField = ({ formik, fieldName, labelName }) => {
  return (
    <>
      <div className="d-col-input-field">
        <label className="form-label">{labelName}</label>
        <div className="input-group">
          <TimePicker
            onChange={(value) =>
              formik.setFieldValue(fieldName, timeFromInt(value))
            }
            onBlur={formik.handleBlur(fieldName)}
            value={formik.values[fieldName]}
            format={24}
            step={15}
          />
        </div>
      </div>
      {formik.touched[fieldName] && formik.errors[fieldName] ? (
        <p className="errors-msg">{formik.errors[fieldName]}</p>
      ) : null}
    </>
  );
};

const LocationInputField = ({
  formik,
  objName,
  fieldName,
  labelName,
  placeHolder,
  disabled
}) => {
  return (
    <div className="d-col-input-field">
      <label className="form-label">{labelName}</label>
      <input
        className="form-control"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        name={`${objName}.${fieldName}`}
        type="text"
        value={formik.values[objName]?.[fieldName] || ""}
        placeholder={placeHolder}
        readOnly={disabled}
      />
      {formik.touched[objName]?.[fieldName] &&
      formik.errors[objName]?.[fieldName] ? (
        <p className="errors-msg">{formik.errors[objName][fieldName]}</p>
      ) : null}
    </div>
  );
};


const DateOfBirthField = ({ formik, fieldName, labelName }) => {
  return (
    <div className="d-col-input-field">
      <label className="form-label">{labelName}</label>
      <DatePicker
        selected={formik.values[fieldName] ? new Date(formik.values[fieldName]) : null}
        value={formik.values[fieldName] ? new Date(formik.values[fieldName]) : null}
        onChange={(value) => formik.setFieldValue(fieldName, value)}
        onBlur={formik.handleBlur(fieldName)}
        name={fieldName}
        dateFormat="dd-MM-yyyy"
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        customInput={
          <input
            className="form-control d-dateIcon"
            type="text"
            autoComplete="off"
          />
        }
        placeholderText="Select Date"
        maxDate={new Date()}
      />
      {formik.touched[fieldName] && formik.errors[fieldName] ? (
        <p className="errors-msg">{formik.errors[fieldName]}</p>
      ) : null}
    </div>
  );
};

export {
  TextInputField,
  TextAreaInputField,
  AddressInputField,
  SelectDropDownField,
  CostInputField,
  TimeInputField,
  DateField,
  DateTimeField,
  LocationInputField,
  DateOfBirthField
};
